import type { ColumnType, DatasetColumn } from '../types/reporting';

/**
 * The fixed output contract for the Patient Roster pipeline.
 *
 * The pipeline query always emits these bare fields. Keep this contract in one
 * frontend module so the compiler, detail-column state, and Fields editor do
 * not independently infer selectable fields from the episodes manifest (which
 * also contains implementation-only columns and related-table references).
 */
export const PATIENT_ROSTER_OUTPUT_COLUMNS: readonly DatasetColumn[] = [
  { name: 'clinic_name', label: 'Clinic', type: 'string' },
  { name: 'patient_first', label: 'Patient first', type: 'string' },
  { name: 'patient_last', label: 'Patient last', type: 'string' },
  { name: 'mrn', label: 'MRN', type: 'string' },
  { name: 'phone', label: 'Phone', type: 'string' },
  { name: 'date_of_birth', label: 'Date of birth', type: 'date' },
  { name: 'age', label: 'Age', type: 'number' },
  { name: 'address', label: 'Address', type: 'string' },
  { name: 'triage_code', label: 'Triage code', type: 'string' },
  { name: 'disaster_code', label: 'Disaster code', type: 'string' },
  { name: 'pdx', label: 'Primary diagnosis', type: 'string' },
  { name: 'sdx', label: 'Secondary diagnosis', type: 'string' },
  { name: 'start_date', label: 'Start date', type: 'date' },
  { name: 'end_date', label: 'End date', type: 'date' },
  { name: 'selected_oasis_date', label: 'Selected OASIS date', type: 'date' },
  { name: 'payer_name', label: 'Payer', type: 'string' },
  { name: 'soc_date', label: 'SOC date', type: 'date' },
  { name: 'physician_name', label: 'Physician', type: 'string' },
  { name: 'physician_npi', label: 'Physician NPI', type: 'string' },
  { name: 'physician_phone', label: 'Physician phone', type: 'string' },
  { name: 'physician_fax', label: 'Physician fax', type: 'string' },
  { name: 'assigned_clinician', label: 'Assigned clinician', type: 'string' },
  {
    name: 'clinician_credentials',
    label: 'Clinician credentials',
    type: 'string',
  },
  { name: 'case_manager', label: 'Case manager', type: 'string' },
  { name: 'clinical_manager', label: 'Clinical Manager', type: 'string' },
  {
    name: 'scheduled_disciplines',
    label: 'Scheduled disciplines',
    type: 'string',
  },
];

export const PATIENT_ROSTER_OUTPUT_FIELDS = PATIENT_ROSTER_OUTPUT_COLUMNS.map(
  column => column.name
);

export const PATIENT_ROSTER_OUTPUT_TYPES: Record<string, ColumnType> =
  Object.fromEntries(
    PATIENT_ROSTER_OUTPUT_COLUMNS.map(column => [column.name, column.type])
  );
